import React from 'react';
import OrderBookComponent from '../../components/OrderBook';
import { Token } from '../../types/supabase';

// Factory function to create the widget
export const createOrderBookWidget = (selectedToken?: Token) => {
  const uniqueKey = `orderbook-${selectedToken?.mint || 'default'}-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
  
  return {
    type: 'order-book',
    title: 'Order Book',
    content: <OrderBookComponent 
      key={uniqueKey}
      selectedToken={selectedToken} 
      isWidget={true} 
    />,
    size: { width: 280, height: 500 },
    contentStyle: { 
      padding: 0,
      overflow: 'hidden'
    },
    glassMorphism: true,
    containerStyle: {
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(12px)',
      borderRadius: '12px',
      border: '1px solid rgba(36, 195, 91, 0.2)',
      boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15), 0 4px 16px rgba(36, 195, 91, 0.2)',
      overflow: 'hidden'
    }
  };
};

// Default export of the component for direct imports
const OrderBook = OrderBookComponent;
export default OrderBook; 